import FaqList from 'Components/03-features/faq';

(function(Drupal) {
  Drupal.behaviors.faqContentType = {
    attach: function(context, settings) {
      window._faqCounterIndex = window._faqCounterIndex || 0;

      Array.from(context.querySelectorAll('.faqs')).map(e => new FaqList(e, { counterIndex: window._faqCounterIndex }));
    }
  };
}(Drupal));
